import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import InfoBox from '../components/info-box';
const BuildingNotFound = (props) => (React.createElement(Fragment, null,
    React.createElement(InfoBox, { msg: "Das Geb\u00E4ude kann nicht gefunden werden - vielleicht probieren Sie es erneut?" }),
    React.createElement("div", { className: "buttons-container ml-3 mr-3" },
        React.createElement(Link, { to: `/${props.mode}/categories`, className: "btn btn-secondary" }, "Zur\u00FCck zu Kategorien"))));
export default BuildingNotFound;
